// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  claimDialog,
  setClaimDialog,
  newClaim,
  setNewClaim,
  fetchClaims,
}) {
  return (
    <Dialog
      open={claimDialog}
      onClose={() => setClaimDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Add Claim</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Claim Name"
          value={newClaim}
          onChange={(e) => setNewClaim(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setClaimDialog(false)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={async () => {
            try {
              await Api.post("/dashboard/add-claim", {
                claim_name: newClaim,
              });

              setNewClaim("");
              setClaimDialog(false);

              await fetchClaims(); // refresh dropdown list

              toast.success("Claim Added");
            } catch (err) {
              console.error(err);
              toast.error("Failed to add claim");
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
